import { paths } from '@mc/paths'
import { caPrivacyPath, doNotSellPath } from 'libs/paths'

export type FooterLink = {
  label: string
  href: string
  geoUS?: boolean
  newTab?: boolean
  showPrivacyIcon?: boolean
}

type FooterColumn = {
  header: string
  links: FooterLink[]
}

const EXPLORE_COLUMN: FooterColumn = {
  header: 'marketingPages.hub.footer.explore.title',
  links: [
    {
      label: 'marketingPages.hub.footer.explore.masterclass',
      href: paths.root,
    },
    {
      label: 'marketingPages.hub.footer.explore.browse',
      href: paths.certificates,
    },
    {
      label: 'marketingPages.hub.footer.explore.onCall',
      href: paths.onCall,
    },
  ],
}

const ABOUT_COLUMN: FooterColumn = {
  header: 'marketingPages.hub.footer.about.title',
  links: [
    {
      label: 'marketingPages.hub.footer.about.careers',
      href: paths.careers,
    },
    {
      label: 'marketingPages.hub.footer.about.privacy',
      href: `https:${paths.privacy}`,
    },
    {
      label: 'marketingPages.hub.footer.about.terms',
      href: paths.terms,
    },
    {
      label: 'marketingPages.hub.footer.about.caPrivacy',
      href: caPrivacyPath(),
      geoUS: true,
    },
    {
      label: 'marketingPages.hub.footer.about.doNotSell',
      href: doNotSellPath(),
      geoUS: true,
      showPrivacyIcon: true,
    },
    {
      label: 'marketingPages.hub.footer.about.support',
      href: paths.helpCenter,
      newTab: true,
    },
  ],
}

const LEARNER_GUIDELINES_LINK: FooterLink = {
  label: 'marketingPages.hub.footer.about.learnerGuidelines',
  href: paths.certificatesLearnerGuidelines,
}

export const getFooterLinks = (isLoggedIn = false) => {
  const aboutColumn = isLoggedIn
    ? {
        ...ABOUT_COLUMN,
        links: [...ABOUT_COLUMN.links, LEARNER_GUIDELINES_LINK],
      }
    : ABOUT_COLUMN

  return [EXPLORE_COLUMN, aboutColumn]
}
